const TRUST_PAGE_CONTENT = Object.freeze({
  about: {
    eyebrow: 'About BotSpot',
    heading: 'Trading automation you can inspect and control',
    summary:
      'BotSpot is an AI trading platform operated by Lumiwealth, Inc., a Delaware corporation.',
    sections: [
      {
        heading: 'What BotSpot does',
        paragraphs: [
          'BotSpot helps customers turn explicit trading rules into editable strategy code, test those rules against historical data, and connect supported brokerage accounts for paper or live operation. Customers can inspect generated code, backtest trades, drawdown, logs, and assumptions before deciding whether to run anything. BotSpot also provides an MCP server so supported AI clients can use the same account tools through documented authentication and scoped permissions.',
          'BotSpot does not hold customer cash or securities. Funds remain at the customer’s broker. BotSpot provides software and connectivity; it is not a broker-dealer or investment adviser, and it does not promise returns. Backtests and paper trading are simulations, while live trading can lose money because of market movement, slippage, liquidity, fees, connectivity, broker rules, and software behavior.',
        ],
      },
      {
        heading: 'Who operates BotSpot',
        paragraphs: [
          'Lumiwealth, Inc. operates BotSpot and publishes its current legal terms and privacy practices on this site. Product plans are paid upfront; BotSpot does not advertise a free product trial. Public pages describe available software, education, marketplace, broker, and agent-integration workflows without inventing performance or access claims.',
        ],
      },
      {
        id: 'rob-grzesik',
        heading: 'Rob Grzesik',
        paragraphs: [
          'Robert Grzesik, known as Rob, is CEO of Lumiwealth BotSpot and creator of the open-source Lumibot trading framework. He teaches the live AI Trading Bootcamp. His published course profile describes a Master of Finance and experience building financial technology; readers can inspect his professional profile and Lumibot project through the links below.',
        ],
      },
      {
        id: 'editorial-policy',
        heading: 'BotSpot editorial team',
        paragraphs: [
          'BotSpot is responsible for the unsigned trading guides, broker pages, and product comparisons published on this site. Named article bylines identify individual authors. Company-authored material is labeled BotSpot; an instructor profile does not mean that instructor personally reviewed every article.',
          'Guides and comparisons link to their source material. A source-verification date records the published reference check; an updated date records an editorial change. Neither means BotSpot independently benchmarked a competing platform or verified a strategy’s future returns. Historical tutorials retain their original publication date and identify outdated interfaces or offers.',
        ],
      },
    ],
    relatedLinks: [
      {
        label: 'Rob Grzesik professional profile',
        url: 'https://www.linkedin.com/in/robertgrzesik/',
      },
      { label: 'Lumibot open-source project', url: 'https://github.com/Lumiwealth/lumibot' },
      { label: 'AI Trading Bootcamp', url: '/courses/ai-trading-bootcamp' },
      { label: 'MCP for Agents', url: '/agents' },
      { label: 'BotSpot Terms of Service', url: '/terms' },
      { label: 'BotSpot Privacy Policy', url: '/privacy' },
      { label: 'Contact BotSpot', url: '/contact' },
    ],
  },
  contact: {
    eyebrow: 'Contact BotSpot',
    heading: 'Reach the team responsible for BotSpot',
    summary:
      'Use the channel that matches your question so account, product, and business requests reach the right context.',
    sections: [
      {
        heading: 'Product and account support',
        paragraphs: [
          'For product setup, account access, billing, broker connections, backtests, deployments, marketplace listings, or MCP integration questions, email support@lumiwealth.com from the address associated with your BotSpot account when possible. Never include passwords, broker secrets, private keys, full API keys, payment-card details, or other authentication credentials in email.',
          'Email is not a trading control. Do not use email to place, change, or cancel an order, stop a live strategy, or report an urgent brokerage problem. Use BotSpot’s visible account controls for BotSpot automation and contact your broker directly for urgent order, position, funding, custody, or market-access issues.',
        ],
      },
      {
        heading: 'General and business inquiries',
        paragraphs: [
          'For partnerships, enterprise services, media, education, or other general questions, email contact@botspot.trade. BotSpot is operated by Lumiwealth, Inc. Product terms, privacy practices, risk disclosures, agent setup, pricing, and supported broker information remain available through public pages linked below so people and automated agents can verify current published claims before contacting the team.',
        ],
      },
    ],
    relatedLinks: [
      { label: 'Email product support', url: 'mailto:support@lumiwealth.com' },
      { label: 'Email BotSpot', url: 'mailto:contact@botspot.trade' },
      { label: 'MCP for Agents', url: '/agents' },
      { label: 'BotSpot Privacy Policy', url: '/privacy' },
    ],
  },
});

function trustPageContent(page) {
  return TRUST_PAGE_CONTENT[page] || null;
}

module.exports = { TRUST_PAGE_CONTENT, trustPageContent };
